import React from 'react';
import { StyledMenu } from './Menu.styled';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import PlayIcon from 'assets/icons/play-button.svg';
import DownloadIcon from 'assets/icons/download.svg';
import { device } from 'helpers/breakpoints';

const Menu = ({ open, ...props }) => {

  const { edges } = props.postMenu;
 
  const isHidden = open ? true : false;
  const tabIndex = isHidden ? 0 : -1;

  const NavLink = styled(Link)`
    transition: all 0.5s ease-in-out
    padding: 30px 30px;
    font-size: 14px;
    color: #000;
    display:grid;
    grid-template-columns: 40px auto 34px;
    align-items: center;
    text-decoration: none;

    span {
      font-size: 16px
      padding: 5px;
    }

    span:first-child {
      font-size: 20px
    }

    svg {
      height:24px;
      fill: #000;
      transition: all 0.5s ease-in-out
    }
  `;
  

  const MenuTitle = styled.h3`
    margin: 5rem 2rem 1rem;
    color: #000;
    text-align: center;
    
    a {
        color: black;
    }
    
    a:hover,
    a:active,
    a:focus {
        opacity: 0.75;
    }

    @media ${device.tablet} { 
      margin-top: 8rem;
    }
  `

  const MenuSubTitle = styled.h4`
  color: #666666;
  text-align: center;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;
  font-weight: 100;

  @media ${device.tablet} { 
    margin-bottom: 3rem;
  }
`

  const MenuDetails = styled.div`
  margin: 0 2rem 1rem ;
  display: flex;
  justify-content: center;
  `

  const VideoList = ({ open }) => {
    return (
      <>
        <MenuTitle>
            <Link to='../'>
               {props.postSection}
            </Link>
        </MenuTitle>
        <MenuSubTitle>{edges.length} Lessons</MenuSubTitle>
        <MenuDetails>
        <div>
            <a className="btn__icon btn__icon--small" href={props.postAssetsURL} download  data-wat-link="true" data-wat-val="Get the assets" data-wat-loc={props.postID + " Navigation Menu"}>
                <span><DownloadIcon/></span> Get the assets
            </a>
        </div>
        </MenuDetails>
       
        <ul>
          {edges.map((item, index) => {
              const isActive = props.currentItem ==  item.node.frontmatter.slug ? "isActive" : null;
            return (
            <li key={index} className={isActive}>
              <NavLink to={item.node.fields.slug}>
                <span>{item.node.frontmatter.position}</span>
                <span>{item.node.frontmatter.cleanTitle}</span>
                <span>
                  <PlayIcon />
                </span>
              </NavLink>
            </li>
          )})}
        </ul>
      </>
    );
  };

  return (
    <StyledMenu open={open} aria-hidden={!isHidden} {...props}>
      <VideoList />
    </StyledMenu>
  );
};

export default Menu;
